var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('single-line-text-input-block',{attrs:{"config":_vm.config,"parent-feature":_vm.parentFeature,"validation-methods":{ isValidEmail: _vm.isValidEmail },"disabled":_vm.disabled,"disabledReason":_vm.disabledReason}})}
var staticRenderFns = []

export { render, staticRenderFns }